/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.19.0
 */

import { ECampaignsType } from './types';
import { getCampaignsInternalPrefilterUrl } from './utils/getCampaignsPageUrl';

export {
    ECampaignsType,
    getCampaignsInternalPrefilterUrl,
};
